<script>
    import { auth } from "../../firebase/auth";
    import ResetPassword from "../../components/authActions/ResetPassword.svelte";
    import RecoverEmail from "../../components/authActions/RecoverEmail.svelte";
    import VerifyEmail from "../../components/authActions/VerifyEmail.svelte";
    
    const params = new URLSearchParams(document.location.search);

    function getParameterByName(name) {
        const param = params.get(name);
        return (param);
    }

    // Get the action to complete.
    const mode = getParameterByName('mode');
    // Get the one-time code from the query parameter.
    const actionCode = getParameterByName('oobCode');
    // (Optional) Get the continue URL from the query parameter if available.
    const continueUrl = getParameterByName('continueUrl');
    // (Optional) Get the language code if available.
    const lang = getParameterByName('lang') || 'en';
</script>

{#if mode==="resetPassword"}
    <!-- Display reset password handler and UI. -->
    <ResetPassword {auth} {actionCode} {continueUrl} {lang}/>
    
{:else if mode==="recoverEmail"}
    <!-- Display email recovery handler and UI. -->
    <RecoverEmail {auth} {actionCode} {continueUrl} {lang}/>
    
{:else if mode==="verifyEmail"}
    <!-- Display email verification handler and UI. -->
    <VerifyEmail {auth} {actionCode} {continueUrl} {lang}/>
    
{:else}
    <!-- Error: invalid mode. -->
    <h1>Ungültiger Link</h1>

{/if}

